module.exports = __webpack_public_path__ + "img/close.af30b9da.svg";